/* unplugin-vue-components disabled */import script from "./blog.vue?vue&type=script&setup=true&lang=js"
export * from "./blog.vue?vue&type=script&setup=true&lang=js"

import "./blog.vue?vue&type=style&index=0&id=275f93b5&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275f93b5"]])

export default __exports__